import { roterPre } from '@/settings';
import Layout from '@/layout';
var defaultRoutes = [{
  path: roterPre,
  component: Layout,
  redirect: "".concat(roterPre, "/user/work"),
  children: [{
    path: "".concat(roterPre, "/user/work"),
    component: function component() {
      return import('@/views/user/workbench/index');
    },
    name: 'dashboard-admin',
    meta: {
      title: '工作台',
      icon: 'dashboard',
      affix: true
    }
  }]
}, {
  path: '/',
  component: Layout,
  redirect: "".concat(roterPre, "/user/work"),
  children: [{
    path: "".concat(roterPre, "/user/work"),
    component: function component() {
      return import('@/views/user/workbench/index');
    },
    name: 'dashboard',
    meta: {
      title: '工作台',
      icon: 'dashboard',
      affix: true
    }
  }, {
    path: "".concat(roterPre, "/search"),
    name: 'search',
    component: function component() {
      return import('@/views/search/index');
    },
    meta: {
      title: '搜索'
    }
  }]
}, {
  path: "".concat(roterPre, "/login"),
  component: function component() {
    return import('@/views/login/index');
  },
  hidden: true
}, {
  path: roterPre + '/401',
  component: function component() {
    return import('@/views/error-page/401');
  },
  hidden: true
}, {
  path: roterPre + '/setting/icons',
  component: function component() {
    return import('@/components/form-common/select-icon.vue');
  },
  name: 'icons'
}, {
  path: roterPre + '/setting/uploadPicture',
  component: function component() {
    return import('@/components/uploadPicture/index.vue');
  },
  name: 'uploadPicture'
}, {
  path: roterPre + '/openFile',
  component: function component() {
    return import('@/components/openFile/index.vue');
  },
  name: 'previewPage',
  meta: {
    title: '文件预览'
  }
}, {
  path: roterPre + '/process',
  component: function component() {
    return import('@/views/develop/crud/process.vue');
  },
  name: 'process'
}, {
  path: roterPre + '/dashboard-design',
  component: function component() {
    return import('@/views/system/dashboard-design/charts/index.vue');
  },
  name: 'dashboardDesign',
  meta: {
    title: '图表设计'
  }
}, {
  path: roterPre + '/event',
  component: function component() {
    return import('@/views/develop/crud/event.vue');
  },
  name: 'event'
}, {
  path: roterPre + '/404',
  component: function component() {
    return import('@/views/error-page/404');
  },
  hidden: true
}];
export default defaultRoutes;